import Login from '../components/Auth/Login'

let routes = {
    path: '/login',
    component: Login
}

export default routes



// WEBPACK FOOTER //
// ./src/router/login.js